import { render, staticRenderFns } from "./CadastroTelefones.vue?vue&type=template&id=0b2c2aad&"
import script from "./CadastroTelefones.vue?vue&type=script&lang=js&"
export * from "./CadastroTelefones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports